var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class Keyboard {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    isKeyPressed(key) {
        if (runtime.isServerRuntime) {
            return false;
        }
        return runtime.solidBrowserRuntime.browserKeyboard.isKeyPressed(key);
    }
    get currentKeyDown() {
        if (runtime.isServerRuntime) {
            return observable.map();
        }
        return runtime.solidBrowserRuntime.browserKeyboard.currentKeyDown;
    }
}
__decorate([
    memoize
], Keyboard.prototype, "currentKeyDown", null);
